import React from 'react';

import { Col, Spinner } from 'react-bootstrap';
import IntegrationCard from './integrationcard';


const IntegrationList = (props) => {
  if (props.isLoading) {
    return (
      <div className="loading-state">
        <Spinner animation="border" role="status" size="sm" />
        <span>Cargando integraciones...</span>
      </div>
    );
  }

  if (props.integrations.length === 0) {
    return (
      <div className="empty-state">
        {
          props.search ?
            <>
              <div className="empty-state-title">Sin resultados para "{props.search}"</div>
              <div>Prueba con otro nombre de sitio.</div>
            </>
            :
            <>
              <div className="empty-state-title">Todavía no hay sitios configurados</div>
              <div>Usa el botón "+" de arriba para activar el primero.</div>
            </>
        }
      </div>
    );
  }

  return (
    <>
      {
        props.integrations.map((integration) => {
          return (
            <Col key={integration.id}>
              <IntegrationCard integration={integration} {...props} />
            </Col>
          )
        })
      }
    </>
  )
}

export default IntegrationList;
